<script>
export default {
  name: 'AutoRows',

  functional: true,

  render: (h, { children }) => {
    children = children.filter(child => child !== undefined && child.tag !== undefined);
    if (children.length === 0) return;

    const output = [];
    const getCol = (children, staticClass) => h('div', { staticClass }, [children]);

    // please keep synchronized with count / 2 from DividedHorizontal
    if (children.length < 2) {
      for (let i = 0; i < children.length; i++) {
        output.push(h('div', { staticClass: 'row' }, [getCol(children[i], 'col-l-12')]));
      }
    } else {
      for (let i = 0; i < children.length; i += 2) {
        const cols = [getCol(children[i], 'col-m-12 col-l-6')];
        if (children[i + 1] !== undefined) {
          cols.push(getCol(children[i + 1], 'col-m-12 col-l-6'));
        }
        output.push(h('div', { staticClass: 'row' }, cols));
      }
    }
    return output;
  },
};
</script>
